import React from "react";
import { Link } from "react-router-dom"; // ✅ Link import added
import "../Component/Component.css/HeroSection.css";
import bgImage from "../Images/Interior Design.png";

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="background-container">
        <img
          className="background-image"
          src={bgImage}
          alt="Nagathane Village"
        />
      </div>

      <div className="overlay">
        <div className="hero-content">
          <h1 className="hero-title">
            “आपलं नागठाणे, आपला अभिमान” आता डिजिटल स्वरूपात
          </h1>

          <p className="hero-description">
            आमच्या गावाच्या विकासाची, परंपरेची, योजना, कामं, कार्यक्रम आणि
            निर्णय आणि लोकसेवेची माहिती आता एका क्लिकवर.
          </p>

          {/* ✅ Buttons with proper links */}
          <div className="hero-buttons">
            <Link to="/about" className="btn btn-primary">
              गावाची माहिती पाहा
            </Link>

            <Link to="/contact" className="btn btn-secondary">
              आमच्याशी संपर्क साधा
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
